import { render, staticRenderFns } from "./31.vue?vue&type=template&id=1d0fde4c&scoped=true&"
import script from "./31.vue?vue&type=script&lang=js&"
export * from "./31.vue?vue&type=script&lang=js&"
import style0 from "./31.vue?vue&type=style&index=0&id=1d0fde4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fde4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d0fde4c')) {
      api.createRecord('1d0fde4c', component.options)
    } else {
      api.reload('1d0fde4c', component.options)
    }
    module.hot.accept("./31.vue?vue&type=template&id=1d0fde4c&scoped=true&", function () {
      api.rerender('1d0fde4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/31.vue"
export default component.exports